// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"78d49450","84":"b0a5cc0a","101":"78fd919b","107":"11f2058c","154":"d802008e","201":"4ccde272","402":"7987508b","719":"c4f836af","838":"4ccde272","961":"68c37419"}[chunkId] + ".chunk.css";
};